import * as DashboardConstants from '.././DashboardConstants';

// export const breakfixTableHeaders = [
//     {
//         key: 'severity',
//         header: DashboardConstants.Severity
//     },
//     {
//         key: 'total',
//         header: DashboardConstants.Total
//     },
//     {
//         key: 'New',
//         header: DashboardConstants.New
//     },
//     {
//         key: 'In Progress',
//         header: DashboardConstants.InProg
//     },
//     {
//         key: 'Canceled',
//         header: DashboardConstants.Cancelled
//     },
//     {
//         key: 'Resolved',
//         header:DashboardConstants.Resolved
//     },
//     {
//         key: 'On Hold',
//         header:  DashboardConstants.OnHold
//     },
//     {
//         key: 'Closed',
//         header: DashboardConstants.Closed
//     }
// ];
// export const breakfixDownloadableTableHeaders = [
//     {
//         key: 'franchise',
//         header: DashboardConstants.Franchise
//     },
//     {
//         key: 'severity',
//         header:  DashboardConstants.Severity
//     },
//     {
//         key: 'total',
//         header: DashboardConstants.Total
//     },
//     {
//         key: 'New',
//         header: DashboardConstants.New
//     },
//     {
//         key: 'In Progress',
//         header: DashboardConstants.InProg
//     },
//     {
//         key: 'Resolved',
//         header:DashboardConstants.Resolved
//     },
//     {
//         key: 'On Hold',
//         header:  DashboardConstants.OnHold
//     },
//     {
//         key: 'Closed',
//         header:  DashboardConstants.Closed
//     }
// ];
export const severityWiseTableHeaders = [
    {
        key: 'item',
        header: DashboardConstants.IncidentStatus
    },
    {
        key: 'count',
        header: DashboardConstants.Count
    }
];
export const reopenCountTableHeaders = [
    {
        key: 'item',
        header: DashboardConstants.Franchise
    },
    {
        key: 'total',
        header: DashboardConstants.Total
    },
    {
        key: 'reOpenCount',
        header: DashboardConstants.ReopenCount
    },
    {
        key: 'percentage',
        header: DashboardConstants.FirstTimeResolve
    }
];
export const reopenCountDownloadableTableHeaders = [
    {
        key: 'item',
        header: DashboardConstants.Franchise
    },
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    {
        key: 'total',
        header: DashboardConstants.Total
    },
    {
        key: 'reOpenCount',
        header: DashboardConstants.ReopenCount
    },
    {
        key: 'percentage',
        header: DashboardConstants.FirstTimeResolve
    }
];
export const incidentAgingTableHeaders = [
    {
        key: 'item',
        header: DashboardConstants.Franchise
    },
    {
        key: 'total',
        header:DashboardConstants.TotalTickets
    },
    {
        key: 'days',
        header: DashboardConstants.AvgAging
    },
];
export const incidentAgingDownloadableHeaders = [
    {
        key: 'item',
        header: DashboardConstants.Franchise
    },
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    {
        key: 'total',
        header: DashboardConstants.TotalTickets
    },
    {
        key: 'days',
        header: DashboardConstants.AvgAging
    },
];
// export const performanceTrendHeaders = [
//     {
//         key: 'week',
//         header: DashboardConstants.TimePeriod
//     },
//     {
//         key: 'total',
//         header: DashboardConstants.Total
//     },
//     {
//         key: 'New',
//         header: DashboardConstants.New
//     },
//     {
//         key: 'In Progress',
//         header: DashboardConstants.InProgress
//     },
//     {
//         key: 'Canceled',
//         header: DashboardConstants.Cancelled
//     },
//     {
//         key: 'On Hold',
//         header:  DashboardConstants.OnHold
//     },
//     {
//         key: 'Resolved',
//         header: DashboardConstants.Resolved
//     },
//     {
//         key: 'Closed',
//         header: DashboardConstants.Closed
//     }
// ]
